/**
 * @file Registers and returns app components.
 * @author Maarten Lensink
 */
/**
 * The class is used to register and retrieve components.
 * @export
 * @class ComponentRegistry
 */
var ComponentRegistry = /** @class */ (function () {
    function ComponentRegistry() {
    }
    /**
     * Registers a component.
     * @static
     * @param {ComponentType} type The component type.
     * @param {string} name The name of the component.
     * @param {Function} component The component itself.
     * @memberOf ComponentRegistry
     */
    ComponentRegistry.register = function (type, name, component) {
        if (ComponentRegistry.components[type][name] !== undefined) {
            throw new Error("A" + (['a', 'e', 'i', 'o'].includes(type[0]) ? 'n' : '') + " " + type + " component called \"" + name + "\" is already registered.");
        }
        ComponentRegistry.components[type][name] = component;
    };
    /**
     * Returns a component if it is registered.
     * @static
     * @param {ComponentType} type The component type.
     * @param {string} name The name of the component.
     * @returns {Function} The component itself.
     * @memberOf ComponentRegistry
     */
    ComponentRegistry.getComponent = function (type, name) {
        if (ComponentRegistry.components[type][name] === undefined) {
            throw new Error("No " + type + " component registered by the name \"" + name + "\".");
        }
        return ComponentRegistry.components[type][name];
    };
    /**
     * The array contains all the registered components.
     * @private
     * @static
     * @type {{ [key in ComponentType]: { [key: string]: Function } }} The type and name of the component.
     * @memberOf ComponentRegistry
     */
    ComponentRegistry.components = {
        'column': {},
        'detail': {},
        'fieldset': {},
        'grid': {},
        'insight': {},
        'list': {},
        'overlay': {},
        'relation': {},
        'route': {}
    };
    return ComponentRegistry;
}());
export { ComponentRegistry };
